// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_CONTRIBUTORS_IN_LAST_WEEK = ["%(count)s \u010dlovek prispel za t\u00fd\u017ede\u0148", "%(count)s \u013eudia prispeli za t\u00fd\u017ede\u0148", "%(count)s \u013eud\u00ed prispelo za t\u00fd\u017ede\u0148"];
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s sk\u00fasenos\u0165", "%(count)s sk\u00fasenosti", "%(count)s sk\u00fasenost\u00ed"];
